import './comp_cadet_record_book.css'

export const Comp_Cadet_Record_Book=(props)=>{
    return(
        <section>

        {/* div-1  */}
        <div class="saperate-page div1 text-start">
        <table>
            <td>
                
            </td>
        </table>
    </div>
        {/* div-2  */}
        
        <div class="saperate-page container-fluid div-2">
        <h5 class="text-center mb-3">INDEX</h5>
        
        <table class="main-table"  cellspacing="0" cellpadding="0">
            <tr>
                {/* <!-- Left Column --> */}
                <td>
                    <table class="content-table">
                        <tr class="section-header">
                            <td colspan="2">Section 1 - Introduction</td>
                        </tr>
                        <tr class="pink-row">
                            {/* <td class="page-col">Page no.</td> */}
                            <td>Content</td>
                        </tr>
                        <tr>
                            {/* <td>9-12</td> */}
                            <td>Section 1.1: Comment</td>
                        </tr>
                        <tr>
                            {/* <td>13</td> */}
                            <td>Section 1.2: Scope</td>
                        </tr>
                        <tr>
                            {/* <td>13-14</td> */}
                            <td>Section 1.3: Objectives</td>
                        </tr>
                        <tr>
                            {/* <td>14</td> */}
                            <td>Section 1.4: Completion Guidelines</td>
                        </tr>
                    </table>
                    
                    <table class="content-table mt-1">
                        <tr class="section-header">
                            <td colspan="2">Section 2 - Roles and Responsibilities</td>
                        </tr>
                        <tr class="pink-row">
                            {/* <td class="page-col">Page no.</td> */}
                            <td>Content</td>
                        </tr>
                        <tr>
                            {/* <td>15</td> */}
                            <td>Roles and Responsibilities</td>
                        </tr>
                    </table>
                    
                    <table class="content-table mt-1">
                        <tr class="section-header">
                            <td colspan="2">Section 3 - General Information</td>
                        </tr>
                        <tr class="pink-row">
                            {/* <td class="page-col">Page no.</td> */}
                            <td>Content</td>
                        </tr>
                        <tr>
                            {/* <td>16</td> */}
                            <td>Section 3.1: Cadet's Particulars</td>
                        </tr>
                        <tr>
                            {/* <td>17</td> */}
                            <td>Section 3.2: Educational Record</td>
                        </tr>
                        <tr>
                            {/* <td>18</td> */}
                            <td>Section 3.3: Professional Training Record</td>
                        </tr>
                        <tr>
                            {/* <td>19</td> */}
                            <td>Section 3.4: Sea Service Record</td>
                        </tr>
                    </table>
                    
                    <table class="content-table mt-1">
                        <tr class="section-header">
                            <td colspan="2">Section 4 - Task Progress Overview</td>
                        </tr>
                        <tr class="pink-row">
                            {/* <td class="page-col">Page no.</td> */}
                            <td>Content</td>
                        </tr>
                        <tr>
                            {/* <td>20-25</td> */}
                            <td>Section 4.1: Shipboard Training Officer's Monthly Review of the Activity Record</td>
                        </tr>
                        <tr>
                            {/* <td>26-31</td> */}
                            <td>Section 4.2: Master's Monthly Review of the Record Book</td>
                        </tr>
                        <tr>
                            {/* <td>32-33</td> */}
                            <td>Section 4.3: Company's/ Maritime Training Institute's Review of the Record Book</td>
                        </tr>
                        <tr>
                            {/* <td>34-49</td> */}
                            <td>Section 4.4: Task Summary Record</td>
                        </tr>
                        <tr>
                            {/* <td>50-55</td> */}
                            <td>Section 4.5: Video / CBT / UBT Activity Record</td>
                        </tr>
                    </table>
                    
                    <table class="content-table mt-1">
                        <tr class="section-header">
                            <td colspan="2">Section 5 - Shipboard Safety and Security Familiarization</td>
                        </tr>
                        <tr class="pink-row">
                            {/* <td class="page-col">Page no.</td> */}
                            <td>Content</td>
                        </tr>
                        <tr>
                            {/* <td>56-60</td> */}
                            <td>Shipboard Safety and Security Familiarization</td>
                        </tr>
                    </table>
                    
                    <table class="content-table mt-1">
                        <tr class="section-header">
                            <td colspan="2">Section 6 - Ship's Particulars</td>
                        </tr>
                        <tr class="pink-row">
                            {/* <td class="page-col">Page no.</td> */}
                            <td>Content</td>
                        </tr>
                        <tr>
                            {/* <td>61-66</td> */}
                            <td>Ship's Particulars</td>
                        </tr>
                    </table>
                </td>
                
                {/* <!-- Middle Column --> */}
                <td>
                    <table class="content-table">
                        <tr class="section-header">
                            <td colspan="2">Section 7: International Regulations for Preventing Collisions at Sea</td>
                        </tr>
                        <tr class="pink-row">
                            {/* <td class="page-col">Page no.</td> */}
                            <td>Content</td>
                        </tr>
                        <tr>
                            {/* <td>67-68</td> */}
                            <td>International Regulations for Preventing Collisions at Sea</td>
                        </tr>
                    </table>
                    
                    <table class="content-table mt-1">
                        <tr class="section-header">
                            <td colspan="2">Section 8 - Onboard Competence/ Tasks</td>
                        </tr>
                        <tr class="pink-row">
                            {/* <td class="page-col">Page no.</td> */}
                            <td>Content</td>
                        </tr>
                        <tr>
                            {/* <td>69-70</td> */}
                            <td>Section 8.1: Task Guidelines</td>
                        </tr>
                        <tr>
                            {/* <td>71-90</td> */}
                            <td>Section 8.2: Tasks for Navigation</td>
                        </tr>
                        <tr>
                            {/* <td>91-95</td> */}
                            <td>Section 8.3: Tasks for Cargo Handling and Stowage</td>
                        </tr>
                        <tr>
                            {/* <td>96-109</td> */}
                            <td>Section 8.4: Tasks for Controlling the Operation of the Ship and Care of Persons on Board including Ship Security</td>
                        </tr>
                        <tr>
                            {/* <td>110-113</td> */}
                            <td>Section 8.5: Additional Tasks for Cargo Operations (Tankers: General)</td>
                        </tr>
                        <tr>
                            {/* <td>114-117</td> */}
                            <td>Section 8.6: Additional Tasks for Cargo Operations (Oil Tankers)</td>
                        </tr>
                        <tr>
                            {/* <td>118-121</td> */}
                            <td>Section 8.7: Additional Tasks for Cargo Operations (Chemical Tankers)</td>
                        </tr>
                        <tr>
                            {/* <td>122-128</td> */}
                            <td>Section 8.8: Additional Tasks for Cargo Operations (Gas Carriers)</td>
                        </tr>
                        <tr>
                            {/* <td>129</td> */}
                            <td>Section 8.9: Additional Tasks for Shipboard Operations on Passenger Ships</td>
                        </tr>
                        <tr>
                            {/* <td>130</td> */}
                            <td>Section 8.10: Additional Tasks for Cargo Operations on Ro-Ro Ships</td>
                        </tr>
                        <tr>
                            {/* <td>131</td> */}
                            <td>Section 8.11: Additional Tasks for Ships Operating in Polar Waters/ Winter Conditions</td>
                        </tr>
                        <tr>
                            {/* <td>132</td> */}
                            <td>Section 8.12: Additional Tasks for Dynamic Positioning (DP) Vessels, Platform Supply Vessels (PSVs) and Offshore Supply Vessels</td>
                        </tr>
                    </table>
                </td>
                
                {/* <!-- Right Column --> */}
                <td>
                    <table class="content-table">
                        <tr class="section-header">
                            <td colspan="2">Section 9 - Record of Watchkeeping and Steering</td>
                        </tr>
                        <tr class="pink-row">
                            {/* <td class="page-col">Page no.</td> */}
                            <td>Content</td>
                        </tr>
                        <tr>
                            {/* <td>133</td> */}
                            <td>Section 9.1: Record of Watchkeeping</td>
                        </tr>
                        <tr>
                            {/* <td>135-140</td> */}
                            <td>Section 9.2: Record of Steering</td>
                        </tr>
                        <tr>
                            {/* <td>141</td> */}
                            <td>Section 9.3: Record of Port Watches</td>
                        </tr>
                        <tr>
                            {/* <td>142</td> */}
                            <td>Section 9.4: Record of Engine Room Watches</td>
                        </tr>
                        <tr>
                            {/* <td>143-148</td> */}
                            <td>Section 9.5: Bridge Watchkeeping Certificate</td>
                        </tr>
                        <tr>
                            {/* <td>149</td> */}
                            <td>Section 9.6: Steering Certificate</td>
                        </tr>
                        <tr>
                            {/* <td>150-155</td> */}
                            <td>Section 9.7: Port Watchkeeping Certificate</td>
                        </tr>
                        <tr>
                            {/* <td>156-161</td> */}
                            <td>Section 9.8: Engine Room Watchkeeping Certificate</td>
                        </tr>
                    </table>
                    
                    <table class="content-table mt-1">
                        <tr class="section-header">
                            <td colspan="2">Section 10 - Project Work</td>
                        </tr>
                        <tr class="pink-row">
                            {/* <td class="page-col">Page no.</td> */}
                            <td>Content</td>
                        </tr>
                        <tr>
                            {/* <td>162</td> */}
                            <td>Section 10.1: Projects - Navigation</td>
                        </tr>
                        <tr>
                            {/* <td>163</td> */}
                            <td>Section 10.2: Projects - Controlling the Operation of the Ship and Care for Persons on Board</td>
                        </tr>
                        <tr>
                            {/* <td>164</td> */}
                            <td>Section 10.3: Additional Projects for Container Vessels</td>
                        </tr>
                        <tr>
                            {/* <td>165</td> */}
                            <td>Section 10.4: Additional Projects for Bulk Carriers</td>
                        </tr>
                        <tr>
                            {/* <td>166</td> */}
                            <td>Section 10.5: Additional Projects for Oil and Product Tankers</td>
                        </tr>
                        <tr>
                            {/* <td>167</td> */}
                            <td>Section 10.6: Additional Projects for Gas Carriers</td>
                        </tr>
                        <tr>
                            {/* <td>168</td> */}
                            <td>Section 10.7: Additional Projects for Heavy Lift Vessels</td>
                        </tr>
                        <tr>
                            {/* <td>169</td> */}
                            <td>Section 10.8: Additional Projects for Car Carriers / Ro-Ro vessels</td>
                        </tr>
                        <tr>
                            {/* <td>170</td> */}
                            <td>Section 10.9: Additional Projects for Forest Product Carriers</td>
                        </tr>
                        <tr>
                            {/* <td>171</td> */}
                            <td>Section 10.10: Additional Projects for Offshore Vessels</td>
                        </tr>
                        <tr>
                            {/* <td>172-179</td> */}
                            <td>Section 11: Samples- Deck Cadet Shipboard Activity Workshop</td>
                        </tr>
                        <tr>
                            {/* <td>180</td> */}
                            <td>Section 12: Abbreviations</td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
    </div>
        
        {/* div-3  */}

        <div class="saperate-page div-3 text-start">
        <table>
            <td>
                <h5>SECTION 1</h5>
                <h5>Introduction</h5>
                <h5>1.1 Comment </h5>
                <p>This Deck Cadet Structured Shipboard Training Programme Record Book attests to satisfactory completion of the tasks required for compliance with the
                    requirements of the International Convention on Standards of Training, Certification and Watchkeeping for Seafarers 1978, as amended in 2010 (STCW
                    2010).<br/>
                    The purpose of th~s programme is to help ensure that a Cadet is enabled to and makes the best use of the time at sea. It lists practical tasks required to be
                    carried out on board, in accordance with the STCW 2010 provisions relating to minimum standards of competence for officers, particularly in charge of a
                    navigational watch on ships of 500 gross tonnage or more (STCW 2010 -Code Table A-llll). It also lists the criteria for assessing the Cadet's progress.<br/>
    
                    The relevant roles and responsibilities of the Maritime Training Institution, Company Training Officer (CTO), Master, Sh~pboard Training Officer (STO) and the
                    Cadet Officer are defined in Section 2. Progress through the programme should be subject to close scrutiny by the Master, by the Cadet's designated
                    Shipboard Training Officer and the Company Training Officer. in instances where the Maritime Training lnstitution oversees the complete training period of
                    the cadet, namely the shore based and the shipboard training phases, the Maritime Training Institution shall assume the role of the Company Training Officer
                    (CTO).<br/>
                    Paragraph 6 'Onboard Training' of Section A-llllof STCW 2010 requires that every candidate for certification as officer in charge of a navigational watch on
                    ships of 500 gross tonnage or more whose seagoing service forms part of a training programme approved as meeting the requirements of that section shall
                    follow an approved programme of onboard training which: <br/>
                    ensures that, during the required period of seagoing service, the candidate receives systematic practical training and experience in the tasks, duties
                    and responsibilities of an officer in charge of a navigational watch, taking into account the guidance given in section 8-1111 of the STCW Code;
                    is closely supervised and monitored by qualified officers aboard the ships in which the approved seagoing service is performed; and
                    is adequately documented in a training record book or similar document<br/>
                    This Deck Cadet Structured Shipboard Training Programme Record Book is designed to meet the above requirements <br/>
                    The assessment method used is on board assessment by the Shipboard Training Officer (STO). The assessment tools are practical demonstration and oral
                    questioning by the STO. Oral questioning is a common assessment technique, which is not time consuming and responses to oral questions provide useful
                    evidence of a cadet's technical knowledge and understanding of shipboard procedures and safety requirements. The purpose is to discuss the relevant task
                    w~th the ST0 in order to obtain clarification, confirmation or supplementation as needed. 
                </p>
                <h5><b>1.2 Scope </b></h5>
                <p>
                    The scope of the practical training enables the Cadet to:<br/>
                    gain experience in relevant aspects of shipboard activities as they occur;<br/>
                    test and compare the knowledge acquired on campus with the daily practice on board;<br/>
                    consolidate and expand theoretical knowledge;<br/>
                    build a practical basis to achieve the standards of competence that accord with the relevant requirements of STCW 2010, Including with table A-Ill1 of
                    STCW 201 0;<br/>
                    build a practical basis to achieve the standards of competence in accordance with Regulation A-V11112 and the corresponding parts of the STCW
                    Code relating to the principles to be observed in keeping a navigational and port watch;<br/>
                    prepare for a future position on board.
                </p>
                <h5><b>1.3 Obiectives</b></h5>
                <p>The Cadet will acquire basic seamanship skills and a practical awareness of the need to follow safe working practices and also be able to keep a navigational
                    watch safely, in accordance with the relevant regulations and recommendations.<br/>
                    The objectives of the programme are to:<br/>
                    direct the practical training so that the Cadet is guided as to the objectives of the practical training period;<br/>
                    give guidance to the Master, Shipboard Training Officer and others regarding the tasks to be performed on board in order to achieve the desired
                    competences;<br/>
                    direct the Assessment Criteria so that the required training outcome can be reliably and fairly proved and documented. 
                </p>
                <h5><b>1.4 Completion Guidelines </b></h5>
                <p>
                   <p><b> On receiut of this book:</b></p>
                    The Cadet should complete the information required in Section 3 (General Information). The Cadet will be personally responsible for the safe keeping of this training
                    programme.
                    <p><b>As soon as possible after joining each ship:</b></p>
                    Section 5 concerning details of Shipboard Safety and Security Familiarization should be completed. An officer should sign to signify that mandatory familiarization as
                    required by the 2010 STCW Convention has been undertaken. <br/>
                    The Cadet should then complete Section 6 concerning the ship's particulars. The Shipboard Training Officer should provide an opportunity for this exercise to be
                    undertaken. <br/>
                    The Shipboard Training Officer should inspect the training programme to check progress. A plan can be formulated and opportunity given for the Cadet to tackle
                    competences that still need to be demonstrated. <br/>
                    <p><b>Throuahout the Cadet's seaaoina service:</b></p>
    
                    Section 8 containing the list of competences 1 tasks should be progressively completed. <br/>
                    The task summary record as shown in Section 4.4 should be Ised for recording the tasks completed In Section 8 and be kept updated. This summary record can be
                    used for planning and tackling the competences and tasks still to be demonstrated. <br/>
                    The training programme should be submitted to the Shipboard Training Officer on joining the ship and subsequently every month for inspection. The Shipboard Training
                    Officer's comments should be recorded and dated in Section 4.1. Comments should only'relate to the Cadet's competence and practical progress in training. <br/>
                    The training programme should be submitted to the Master for inspection every month. The Master's comments should be recorded, dated and stamped in Section 4.2.
                    Comments should only relate to the Cadet's competence and practical progress In training. <br/>
                    A precise record should be kept of the Cadet's seagoing service including time spent on steering, bridge watchkeeping duties and port and anchor watches. Please
                    refer to Section 9 for more details. <br/>
                    In addition to the practical training, the Cadet should improve understanding of the International Regulations for Preventing Collisions at Sea, as provided in Section 7,
                    and their implementation. <br/>
                    The Cadet is also required to do the project work as provided in Section 10. 
                </p>
                    
            </td>
        </table>
    </div>
        
        {/* div-4  */}
        
        <div class="saperate-page div-4  text-start">
    <table class="section2-table">
        <h5>SECTION 2</h5>
    <h5>Roles and Responsibilities</h5>
    
    <p>The main roles and responsibilities of the personnel involved in the delivery of a structured shipboard training programme are:</p>
    
    <table>
        <tr>
            <th>Maritime Training Institution*</th>
            <th>Company Training Officer</th>
            <th>Master</th>
            <th>Shipboard Training Officer</th>
            <th>Cadet Officer</th>
        </tr>
        <tr>
            <td>Overall administration of the training programme including the pre-sea training period.</td>
            <td>Overall administration of the structured shipboard training programme.</td>
            <td>Provides the link between the Shipboard Training Officer and the Company Training Officer/ Maritime Training Institution ashore.</td>
            <td>Responsible for organizing the programme of practical training at sea.</td>
            <td>Diligently follows the training programme.</td>
        </tr>
        <tr>
            <td>Issues guidance as required and ensures that all concerned with the training programme play their parts.</td>
            <td>Issues guidance as required and ensures that all concerned with the training programme play their parts.</td>
            <td>Ensures that all concerned are effectively carrying out the training programme.</td>
            <td>Ensures in a supervisory capacity, that the training programme is properly maintained and all requirements fulfilled. Ensures that the time the Cadet spends on board is as useful as possible in terms of training and experience, and activities are consistent with the objectives of the training programme, the progress of training and the ship's operational constraints. Uses the assessment criteria on the right hand side of the page and if satisfied that the Cadet can perform the tasks without supervision, signs and dates the "considered proficient" column.</td>
            <td>Makes the most of the opportunities presented, within or outside working hours. Completes the tasks prescribed in the training programme to the best of ability, demonstrates the completion to the Shipboard Training Officer and obtains initialed approval.</td>
        </tr>
        <tr>
            <td>Monitors the progress of the Cadet. Checks and comments on the appraisal report sent by the Shipboard Training Officer.</td>
            <td>Monitors the progress of the Cadet. Checks and comments on the appraisal report sent by the Shipboard Training Officer.</td>
            <td>Inspects the training programme at monthly intervals and gives comments and suggestions for further improvement.</td>
            <td>Inspects the training programme at monthly intervals and gives comments/ suggestions for further improvement. Sends a quarterly appraisal report on the Cadet's performance.</td>
            <td>Keeps the training programme updated and available for scrutiny at all times.</td>
        </tr>
    </table>
    
    <p class="footnote">* In many administrations the pre-sea maritime training institution takes the responsibility of monitoring the SSTP Record Book and finally certifying that the entire training programme has been satisfactorily completed.</p>
    </table>
   </div>
    
    {/* div-5  */}

    <div class="saperate-page section3-table div-5 text-start">
        <h5>SECTION 3</h5>
        <h5>3.1: Cadet's Particulars</h5>
        
        <p>Particulars of Cadet to be completed by the Cadet in BLOCK letters:</p>
        
        <table class="form-table">
            <tr>
                <td>
                    <div class="form-field">
                        First Name: <input type="text"/>
                    </div>
                    <div class="form-field">
                        Middle Name: <input type="text"/>
                    </div>
                    <div class="form-field">
                        Last Name: <input type="text"/>
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    <div class="form-field">
                        Date of Birth: <input type="text"/>
                    </div>
                    <div class="form-field">
                        Place of Birth: <input type="text"/>
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    <div class="form-field">
                        Passport No.: <input type="text"/>
                    </div>
                    <div class="form-field">
                        CDC No.: <input type="text"/>
                    </div>
                    <div class="form-field">
                        INDOS No.: <input type="text"/>
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    <div>Home Address:</div>
                    <input type="text" class="long-field"/>
                    <input type="text" class="long-field"/>
                </td>
            </tr>
            <tr>
                <td>
                    <div class="form-field">
                        Phone: <input type="text"/>
                    </div>
                    <div class="form-field">
                        Fax: <input type="text"/>
                    </div>
                    <div class="form-field">
                        E-mail: <input type="text"/>
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    <div class="form-field">
                        Date Of Entry: <input type="text"/>
                    </div>
                    <div class="form-field">
                        Height: <input type="text" style={{width: '50px'}}/> cm.
                    </div>
                    <div class="form-field">
                        Weight: <input type="text" style={{width: '50px'}}/> Kg
                    </div>
                    <div class="form-field">
                        Blood Group: <input type="text"/>
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    <div>Distinguishing Marks: <input type="text" class="long-field"  style={{width: '70%'}}/></div>
                </td>
            </tr>
            <tr>
                <td>
                    <div>Sponsoring Company: <input type="text" class="long-field"  style={{width: '70%'}}/></div>
                </td>
            </tr>
            <tr>
                <td>
                    <div>Address: <input type="text" class="long-field"/></div>
                    <input type="text" class="long-field"/>
                </td>
            </tr>
            <tr>
                <td>
                    <div>Name, Address and Relationship of Next of Kin: <input type="text" class="long-field"  style={{width: '50%'}}/></div>
                    <input type="text" class="long-field"/>
                </td>
            </tr>
            <tr>
                <td>
                    <div class="form-field">
                        Phone: <input type="text"/>
                    </div>
                    <div class="form-field">
                        Fax: <input type="text"/>
                    </div>
                    <div class="form-field">
                        E-mail: <input type="text"/>
                    </div>
                </td>
            </tr>
        </table>
    </div>


 {/* div-6  */}
        
 <div class="div-6 saperate-page text-start">
        <h5>3.2 Educational Record</h5>
        
        <p><strong>GCE "O" level / Class X</strong></p>
        
        <div class="form-field">
            <span class="field-label">Name and address of the school:</span>
            <span class="input-line">&nbsp;</span>
        </div>
        
        <div class="form-field">
            <span class="field-label">Date certificate issued:</span>
            <span class="input-line">&nbsp;</span>
        </div>
        
        <table>
            <tr>
                <th>Subjects</th>
                <th>Grade/ Marks</th>
            </tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
        </table>
        
        <p><strong>GCE "A" level / Class XII</strong></p>
        
        <div class="form-field">
            <span class="field-label">Name and address of the school:</span>
            <span class="input-line">&nbsp;</span>
        </div>
        
        <div class="form-field">
            <span class="field-label">Date certificate issued:</span>
            <span class="input-line">&nbsp;</span>
        </div>
        
        <table>
            <tr>
                <th>Subjects</th>
                <th>Grade/ Marks</th>
            </tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
        </table>
    </div>

{/* div-7  */}

<div class="div-7 saperate-page text-start">
    <h5>3.3 Professional Training Record</h5>
    <div class="section-title">Cadet's Training Programme</div>
    
   
    <table>
        <tr>
            <th>Pre-Sea Training<br/>Name of the College</th>
            <th>Date (From)</th>
            <th>Date (To)</th>
        </tr>
        <tr class="empty-row"><td></td><td></td><td></td></tr>
    </table>
    
    
    <table>
        <tr>
            <th>On-Board Training<br/>Name of the Ship</th>
            <th>Date (From)</th>
            <th>Date (To)</th>
        </tr>
        <tr class="empty-row"><td></td><td></td><td></td></tr>
        <tr class="empty-row"><td></td><td></td><td></td></tr>
        <tr class="empty-row"><td></td><td></td><td></td></tr>
        <tr class="empty-row"><td></td><td></td><td></td></tr>
    </table>
    
   
    <div class="section-title">Basic Training as Required by STCW 2010- Section A-VI/1</div>
    <table>
        <tr>
            <th>Course</th>
            <th>Date</th>
            <th>Name of Institution</th>
            <th>Location</th>
            <th>Certificate number</th>
        </tr>
        <tr>
            <td>Personal Survival Techniques</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Fire prevention and Fire fighting</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Elementary First Aid</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Personal Safety and Social Responsibilities</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Security Training for persons with designated duties</td>
            <td></td><td></td><td></td><td></td>
        </tr>
    </table>
    
   
    <div class="section-title">Record of Other Professional Training</div>
    <table>
        <tr>
            <th>Course</th>
            <th>Date</th>
            <th>Name of Institution</th>
            <th>Location</th>
            <th>Certificate number</th>
        </tr>
        <tr>
            <td>Proficiency in Survival Craft & Rescue Boat</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Radar Observer Course</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Automatic Radar Plotting Aids</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Medical First Aid</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>GMDSS General Operator's Certificate</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Oil and Chemical Tanker Familiarization</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Gas Tanker Familiarization</td>
            <td></td><td></td><td></td><td></td>
        </tr>
    </table>
   </div>

{/* div-8  */}

<div class="div-8 saperate-page text-start">
        <div class="title">3.4 Record of Sea Service</div>
    
    <table>
        <thead>
            <tr>
                <th rowspan="2" class="ship-col">Ship</th>
                <th rowspan="2" class="imo-col">IMO Number</th>
                <th colspan="2" class="date-col">Date</th>
                <th colspan="2" class="time-header">Time spent on bridge watchkeeping duties</th>
                <th colspan="2" class="time-header">Voyage total seagoing service</th>
            </tr>
            <tr>
                <th>Signed on</th>
                <th>Signed off</th>
                <th>Months</th>
                <th>Days</th>
                <th>Months</th>
                <th>Days</th>
            </tr>
        </thead>
        <tbody>
            <tr class="empty-row">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr class="empty-row">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr class="empty-row">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr class="empty-row">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr class="empty-row">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr class="empty-row">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr class="total-row">
                <td colspan="4">Total Time</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </tbody>
    </table>
    </div>

{/* div-9  */}


<div class="div-9 saperate-page text-start">
        <div class="section-title">SECTION 4</div>
        <div class="sub-title">4.1 Shipboard Training Officer's Monthly Review of the Record Book</div>
        <div class="instructions">
            Comments should only relate to the Cadet's practical progress in training and competence.<br/>
            (The first two rows give examples of monthly entries)
        </div>
        
        <table>
            <thead>
                <tr>
                    <th style={{width: '5%'}}></th>
                    <th style={{width: '15%'}}>Ship</th>
                    <th style={{width: '30%'}}>Comments</th>
                    <th style={{width: '20%'}}>Shipboard Training Officer's Name</th>
                    <th style={{width: '20%'}}>Shipboard Training Officer's Signature and Stamp</th>
                    <th style={{width: '10%'}}>Date</th>
                </tr>
            </thead>
            <tbody>
               
                <tr>
                    <td>1.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>2.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>3.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>4.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>5.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>6.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>7.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>8.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>9.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>10.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>11.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>12.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>13.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>14.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>15.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>16.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>17.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>18.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>19.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>20.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>21.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>22.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
        </table>
    </div>

 {/* div-10  */}
 <div class="div-10 saperate-page text-start">
        <div class="header">
            <h2>4.2 Master's Monthly Review of the Record Book</h2>
        </div>
        
        <div class="instructions text-start">
            Comments should only relate to Cadet's practical progress in training and competence.<br/>
            (First two rows indicate examples of filling the monthly review)
        </div>
        
        <table>
            <thead>
                <tr>
                    <th width="5%"></th>
                    <th width="15%">Ship</th>
                    <th width="30%">Comments</th>
                    <th width="15%">Master's Name</th>
                    <th width="15%">Master's Signature</th>
                    <th width="10%">Date</th>
                    <th width="15%">Ship's Official Stamp</th>
                </tr>
            </thead>
            <tbody>
               
                <tr>
                    <td>1.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>2.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>3.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>4.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>5.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>6.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>7.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>8.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>9.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>10.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>11.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>12.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>13.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>14.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>15.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>16.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>17.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>18.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>19.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>20.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>21.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>22.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
        </table>
        
    </div>

{/* div-11  */}
<div class="div11 saperate-page text-start">
    <h6>4.3 Company's/ Maritime Training Institution’s Review of the Record Book</h6>
    <p class="note">Comments should only relate to the Cadet’s practical progress in training and competence.</p>

    <table>
        <thead>
            <tr>
                <th>Comments</th>
                <th>Name</th>
                <th>Designation</th>
                <th>Signature</th>
                <th>Date</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td style={{height: '50px'}}></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td style={{height: '50px'}}></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td style={{height: '50px'}}></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td style={{height: '50px'}}></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </tbody>
    </table>

   
</div>

{/* div-12  */}
<div class="div-12 saperate-page text-start">
<h6>4.4 Task Summary Record</h6>
<p>The purpose of this summary record is to provide a continuous check on the status of the tasks. The Cadet should tick the tasks successfully completed. The
wlor wde for the tasks is:<br/>
Semester 3: Yellow<br/>
Semester 4: Green<br/>
Semester 5: Blue<br/>
Each phase is of 6 months. There is no colour codlng for specialized ships as the tasks on such ships are not segregated into phases.
The task summary record should be used for recording the tasks completed in Section 8 and be kept updated. In the boxes below the task number, tick off
those tasks which are completed and signed by the ST0 (In section 8).<br/>
Every quarter, the cadet needs to make a photocopy of all the Task Summary sheets (4.4.8 Summarv Record of all taskg). He shall then get these
photowp~ed Summary sheets signed, dated, stamped and attested by the STO. These may then be sent by post or a scanned oopy by email to the Company
Training Officer (CTO) who in turn will pass it to his Pre-Sea Maritime Training Institute.<br/>
Specimen signatures of all officers who have signed on this record book should be documented in the table below. 
</p>
</div>

{/* div-13  */}
<div class="div-13 saperate-page text-start">
<h5>4.4 A Record of Specimen signatures </h5>
<table>
        
        <thead>
            <tr>
                <th>Vessel Name</th>
                <th>Name of Officer</th>
                <th>Rank</th>
                <th>Specimen Signature</th>
                <th>Date Signed On</th>
                <th>Date Signed Off</th>
            </tr>
        </thead>
        <tbody>
 
            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
        </tbody>
    </table>
</div>


{/* div-14  */}
<div class="div-14 saperate-page text-start">
    <h5 class="text start">TASK SUMMARY RECORD</h5>
    <h5 class="text start">Semester 3</h5>
    <h6 class="text start">Navigation</h6>
    <div class="div-a text-start">
        <table>
            <tbody>
                <tr>
                    <td rowspan="6">A1- Plan and conduct a passage and determine position</td>
                    <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MQ==&rd_index=undefined">1.1.1</a></td>
                    <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=Mg==&rd_index=undefined">1.1.2</a></td>
                    <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NQ==&rd_index=undefined">1.1.3</a></td>
                    <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=Ng==&rd_index=undefined">1.2.1</a></td>
                    <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=OQ==&rd_index=undefined">1.2.2</a></td>
                    <td class="highlighted">1.2.3</td>
                    <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTE=&rd_index=undefined">1.2.5</a></td>
                    <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTA=&rd_index=undefined">1.2.4</a></td>
                    <td class="highlighted">1.3.1</td>
                    <td class="highlighted">1.3.2</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td class="highlighted"><a  class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTI=&rd_index=undefined">1.3.3</a></td>
                    <td class="highlighted">1.3.4</td>
                    <td class="highlighted"><a  class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTQ=&rd_index=undefined">1.5.1</a></td>
                    <td class="highlighted"><a  class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTU=&rd_index=undefined">1.6.1</a></td>
                    <td class="highlighted"><a  class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTY=&rd_index=undefined">1.7.1</a></td>
                    <td class="highlighted"><a  class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTY=&rd_index=undefined">1.7.2</a></td>
                    <td class="highlighted"><a  class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTY=&rd_index=undefined">1.7.3</a></td>
                    <td class="highlighted">1.7.4</td>
                    <td class="highlighted"><a  class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTk=&rd_index=undefined">1.8.1</a></td>
                    <td class="highlighted"><a  class="chrf" chrf="">1.8.2</a></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td class="highlighted">1.8.3</td>
                    <td class="highlighted"><a  class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MjI=&rd_index=undefined">1.9.1</a></td>
                    <td class="highlighted">1.9.2</td>
                    <td class="highlighted">1.9.3</td>
                    <td class="highlighted">1.9.4</td>
                    <td class="highlighted">1.9.5</td>
                    <td class="highlighted">1.9.6</td>                
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td rowspan="2" class="text-start">A2- Maintain a safe navigational watch</td>
                    <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=Mjg=&rd_index=undefined">2.1.1</a></td>
                    <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=Mjg=&rd_index=undefined">2.1.2</a></td>
                    <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=Mjg=&rd_index=undefined">2.1.3</a></td>
                    <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MzE=&rd_index=undefined">2.2.1</a></td>
                    <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MzI=&rd_index=undefined">2.3.1</a></td>
                    <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MzM=&rd_index=undefined">2.4.1</a></td>
                </tr>
               <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
               </tr>
               <tr>
                <td rowspan="2" class="text-start">A3 Use of radar abd ARPA to maintain safety of navigation</td>
                <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MzQ=&rd_index=undefined">3.1.1</a></td>
                <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MzQ=&rd_index=undefined">3.1.2</a></td>
                <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MzQ=&rd_index=undefined">3.1.3</a></td>
                <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MzQ=&rd_index=undefined">3.1.4</a></td>
                <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MzQ=&rd_index=undefined">3.1.5</a></td>
                <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MzQ=&rd_index=undefined">3.1.6</a></td>
                <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MzQ=&rd_index=undefined">3.2.1</a></td>
               </tr>
               <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
               </tr>
               <tr>
                <td rowspan="2" class="text-start">A4-use of ECDIS to maintain the safety of navigation</td>
                <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NDE=&rd_index=undefined">4.1.1</a></td>
                <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NDE=&rd_index=undefined">4.1.2</a></td>
                <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NDE=&rd_index=undefined">4.1.3</a></td>
               </tr>
               <tr>
                <td></td>
                <td></td>
                <td></td>
               </tr>
               <tr>
                <td rowspan="2" class="text-start">A5- Respond to emergencies</td>
                <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NDQ=&rd_index=undefined">5.1.1</a></td>
                <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NDU=&rd_index=undefined">5.2.1</a></td>
                <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NDU=&rd_index=undefined">5.2.2</a></td>
               </tr>
               <tr>
                <td></td>
                <td></td>
                <td></td>
               </tr>
               <tr>
                <td rowspan="2" class="text-start">A6 Respond to a distress signal at sea</td>
                <td class="highlighted">6.1.1</td>
                <td class="highlighted">6.1.2</td>
                <td class="highlighted">6.1.3</td>
                <td class="highlighted">6.1.4</td>
                <td class="highlighted">6.1.5</td>
               </tr>
               <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
               </tr>
               <tr>
                <td rowspan="2" class="text-start">A7 Use the IMO standard marine Communication Phrases and use  English in written or oral form</td>
                <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NTM=&rd_index=undefined">7.2.1</a></td>
                <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NTM=&rd_index=undefined">7.2.2</a></td>
                <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NTM=&rd_index=undefined">7.2.3</a></td>
                </tr>
               <tr>
                <td></td>
                <td></td>
                <td></td>
               </tr>
               <tr>
                <td rowspan="2" class="text-start">A8 Transit and recieve information by visual signaling</td>
                <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NTY=&rd_index=undefined">8.2.1</a></td>
                <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NTY=&rd_index=undefined">8.2.2</a></td>
                <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NTY=&rd_index=undefined">8.2.3</a></td>
                <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NTY=&rd_index=undefined">8.2.4</a></td>
               </tr>
               <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                 </tr>
                <tr>
                    <td rowspan="2" class="text-start">A9 - Manoeuvre the ship</td>
                    <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NjA=&rd_index=undefined">9.1.1</a></td>
                    <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NjA=&rd_index=undefined">9.1.2</a></td>
                    <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NjA=&rd_index=undefined">9.1.3</a></td>
                    <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NjA=&rd_index=undefined">9.1.4</a></td>
                    <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NjQ=&rd_index=undefined">9.2.1</a></td>
                    <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NjQ=&rd_index=undefined">9.2.2</a></td>
                    <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NjQ=&rd_index=undefined">9.2.3</a></td>
                    <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NjQ=&rd_index=undefined">9.2.4</a></td>
                    <td class="highlighted"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NjQ=&rd_index=undefined">9.2.5</a></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="div-b text-start">
        <h6 class="text start">Cargo handling and Stowage</h6>
            <table>
                <tbody>
                    <tr>
                        <td rowspan="4">B1- Monitor the loading, stowage,
                            securing, care during the voyage and the -
                            unloading of cargoes</td>
                        <td class="highlighted">1.1.1</td>
                        <td class="highlighted">1.1.2</td>
                        <td class="highlighted">1.1.3</td>
                        <td class="highlighted">1.1.4</td>
                        <td class="highlighted">1.1.5</td>
                        <td class="highlighted">1.3.1</td>
                        <td class="highlighted">1.3.2</td>
                        <td class="highlighted">1.3.3</td>
                        <td class="highlighted">1.3.4</td>
                        <td class="highlighted">1.3.5</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td class="highlighted">1.5.1</td>
                        <td class="highlighted">1.5.2</td>
                        <td class="highlighted">1.5.3</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td rowspan="2">B2- Inspect and report defects and damage
                            to cargo spaces, hatch covers and ballast
                            tanks</td>
                            <td class="highlighted">2.1.1</td>
                            <td class="highlighted">2.1.2</td>
                            <td class="highlighted">2.1.3</td>
                            <td class="highlighted">2.1.4</td>
                            <td class="highlighted">2.1.5</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    </tbody>
        </table>
    </div>
    <div class="div-c text-start">
        <h6 class="text start">Controllinq the operation of the ship and care for persons on board</h6>
        <table>
            <tbody>
                <tr>
                    <td rowspan="2" class="text-start">C1- Ensure compliance with pollutionprevention requirements</td>
                    <td class="highlighted">1.1.1</td>
                    <td class="highlighted">1.1.2</td>
                    <td class="highlighted">1.1.3</td>
                    <td class="highlighted">1.2.1</td>
                    <td class="highlighted">1.2.2</td>
                    <td class="highlighted">1.2.3</td>
                    <td class="highlighted">1.2.4</td>
                    <td class="highlighted">1.3.1</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td rowspan="4" class="text-start">C2- Maintain seaworthiness of the ship</td>
                    <td class="highlighted">2.2.1</td>
                    <td class="highlighted">2.3.1</td>
                    <td class="highlighted">2.3.2</td>
                    <td class="highlighted">2.3.3</td>
                    <td class="highlighted">2.4.1</td>
                    <td class="highlighted">2.4.2</td>
                    <td class="highlighted">2.4.3</td>
                    <td class="highlighted">2.4.4</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td class="highlighted">2.4.5</td>
                    <td class="highlighted">2.4.6</td>
                    <td class="highlighted">2.4.7</td>
                    <td class="highlighted">2.4.8</td>
                    <td class="highlighted">2.4.9</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td rowspan="2" class="text-start">C3- Prevent, control and fight fires on 1 board</td>
                    <td class="highlighted">3.1.1</td>
                    <td class="highlighted">3.1.2</td>
                    <td class="highlighted">3.1.3</td>
                    <td class="highlighted">3.1.4</td>
                    <td class="highlighted">3.1.5</td>
                    <td class="highlighted">3.1.6</td>
                    <td class="highlighted">3.1.7</td>
                    <td class="highlighted">3.2.1</td>
                    <td class="highlighted">3.2.2</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td rowspan="2" class="text-start">C4- Operate life-saving appliances</td>
                    <td class="highlighted">4.1.1</td>
                    <td class="highlighted">4.1.2</td>
                    <td class="highlighted">4.1.3</td>
                    <td class="highlighted">4.1.4</td>
                    <td class="highlighted">4.1.5</td>
                    <td class="highlighted">4.1.6</td>
                    <td class="highlighted">4.1.7</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td rowspan="2" class="text-start">C5- Apply medical first aid on board ship</td>
                    <td class="highlighted">5.1.1</td>
                    <td class="highlighted">5.1.2</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td rowspan="2" class="text-start">C6- Monitor compliance with legislative requirements </td>
                    <td class="highlighted">6.1.1</td>
                    <td class="highlighted">6.1.2</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td rowspan="2" class="text-start">C7- Contribute to the safetv -. of oersonnel I and ship </td>
                    <td class="highlighted">7.1.1</td>
                    <td class="highlighted">7.1.2</td>
                    <td class="highlighted">7.1.3</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="div-d text-start">
        <h6 class="text-start">Ship security</h6>
        <table>
            <tbody>
                <tr>
                    <td rowspan="2"  class="text-start">Dl- Contribute to the enhancement of
                        maritime security through heightened
                        awareness </td>
                        <td class="highlighted">1.1.1</td>
                        <td class="highlighted">1.1.2</td>
                        <td class="highlighted">1.1.3</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>

                </tr>
            </tbody>
        </table>
    </div>
   </div>



{/* div-15  */}

 <div class="div-15 saperate-page text-start">
      <h5>Semester 4</h5>
      <div class="div-a">
        <h6>Navigation</h6>
        <table>
          <tr>
            <td rowspan="6">
              A1- Plan and conduct a passage and determine position
            </td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NzE=&rd_index=undefined">1.1.4</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NzE=&rd_index=undefined">1.1.5</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NzE=&rd_index=undefined">1.1.6</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NzE=&rd_index=undefined">1.1.7</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NzE=&rd_index=undefined">1.1.8</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NzI=&rd_index=undefined">1.1.9</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NzM=&rd_index=undefined">1.2.6</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NzQ=&rd_index=undefined">1.3.5</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NzQ=&rd_index=undefined">1.3.6</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NzQ=&rd_index=undefined">1.3.7</a></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NzQ=&rd_index=undefined">1.3.8</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NzQ=&rd_index=undefined">1.3.9</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NzQ=&rd_index=undefined">1.3.10</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NzQ=&rd_index=undefined">1.3.11</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NzQ=&rd_index=undefined">1.3.12</a></td>
            <td class="competency">1.3.13</td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NzU=&rd_index=undefined">1.3.14</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=NzY=&rd_index=undefined">1.6.2</a></td>
            <td class="competency">1.7.5</td>
            <td class="competency">1.9.7</td>
          </tr>
          <tr> 
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td class="competency">1.9.8</td>
          </tr>
          <tr>
            <td></td>
          </tr>
          <tr>
            <td rowspan="2">A2- Maintain a safe navigational watch</td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=Nzk=&rd_index=undefined">2.1.4</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=Nzk=&rd_index=undefined">2.1.5</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=Nzk=&rd_index=undefined">2.1.6</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=ODA=&rd_index=undefined">2.2.2</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=ODA=&rd_index=undefined">2.2.3</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=ODE=&rd_index=undefined">2.2.4</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=ODI=&rd_index=undefined">2.3.2</a></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td rowspan="2">
              A3- Use of radar and ARPA to maintain safety of navigation
            </td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=ODM=&rd_index=undefined">3.1.7</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=ODM=&rd_index=undefined">3.1.8</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=ODQ=&rd_index=undefined">3.2.2</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=ODQ=&rd_index=undefined">3.2.3</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=ODQ=&rd_index=undefined">3.2.4</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=ODQ=&rd_index=undefined">3.2.5</a></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td rowspan="2">
              A4- Use of ECDIS to maintain the safety of navigation
            </td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=ODU=&rd_index=undefined">4.1.4</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=ODU=&rd_index=undefined">4.1.5</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=ODU=&rd_index=undefined">4.1.6</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=ODU=&rd_index=undefined">4.1.7</a></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td rowspan="2">A5- Respond to emergencies</td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=ODY=&rd_index=undefined">5.1.2</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=ODc=&rd_index=undefined">5.2.3</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=ODc=&rd_index=undefined">5.2.4</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=ODc=&rd_index=undefined">5.2.5</a></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td rowspan="2">A6- Respond to a distress signal at sea</td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=ODg=&rd_index=undefined">6.1.6</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=ODk=&rd_index=undefined">6.1.7</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=ODk=&rd_index=undefined">6.1.8</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=ODk=&rd_index=undefined">6.1.9</a></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td rowspan="2">
              A7- Use the IMO Standard Marine 1 Communication Phrases and use
              English 1 in written and oral form
            </td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=OTA=&rd_index=undefined">7.1.1</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=OTE=&rd_index=undefined">7.2.4</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=OTI=&rd_index=undefined">7.2.5</a></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td rowspan="2">
              A8- Transmit and receive information by visual signalling
            </td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=OTM=&rd_index=undefined">8.1.1</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=OTM=&rd_index=undefined">8.1.2</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=OTQ=&rd_index=undefined">8.1.3</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=OTU=&rd_index=undefined">8.2.5</a></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td rowspan="2">A9- Manoeuvre the ship</td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=OTY=&rd_index=undefined">9.2.6</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=OTY=&rd_index=undefined">9.2.7</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=OTY=&rd_index=undefined">9.2.8</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=OTc=&rd_index=undefined">9.2.9</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=OTc=&rd_index=undefined">9.2.10</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=OTc=&rd_index=undefined">9.2.11</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=OTc=&rd_index=undefined">9.2.12</a></td>
            <td class="competency"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=OTc=&rd_index=undefined">9.2.13</a></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </table>
      </div>
      <div class="div-b">
        <h6>Cargo handling and stowage</h6>
        <table>
          <tr>
            <td rowspan="2">
              B1 Monitor the loading, stowage, care during the vpyage and the
              unloading of cargos
            </td>
            <td class="competency">1.1.6</td>
            <td class="competency">1.2.1</td>
            <td class="competency">1.2.2</td>
            <td class="competency">1.2.3</td>
            <td class="competency">1.2.4</td>
            <td class="competency">1.2.5</td>
            <td class="competency">1.3.6</td>
            <td class="competency">1.3.7</td>
            <td class="competency">1.3.8</td>
            <td class="competency">1.3.9</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td rowspan="2">
              82- Inspect and report defects and damage to cargo spaces, hatch
              covers and ballast tanks
            </td>
            <td class="competency">2.1.6</td>
            <td class="competency">2.1.7</td>
            <td class="competency">2.1.8</td>
            <td class="competency">2.1.9</td>
            <td class="competency">2.1.10</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </table>
      </div>
      <div class="div-c">
        <h6>
          Controlling the operation of the ship and care for persons on board
        </h6>
        <table>
          <tr>
            <td rowspan="2">
              C1 Ensure compliance with pollution prevention requirements
            </td>
            <td class="competency">1.1.4</td>
            <td class="competency">1.1.5</td>
            <td class="competency">1.1.6</td>
            <td class="competency">1.1.7</td>
            <td class="competency">1.2.5</td>
            <td class="competency">1.2.6</td>
            <td class="competency">1.2.7</td>
            <td class="competency">1.3.2</td>
            <td class="competency">1.3.3</td>
            <td class="competency">1.3.4</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td rowspan="4">C2 Maintain seaworthiness of the ship</td>
            <td class="competency">2.1.1</td>
            <td class="competency">2.3.4</td>
            <td class="competency">2.4.10</td>
            <td class="competency">2.4.11</td>
            <td class="competency">2.4.12</td>
            <td class="competency">2.4.13</td>
            <td class="competency">2.4.14</td>
            <td class="competency">2.4.15</td>
            <td class="competency">2.4.16</td>
            <td class="competency">2.4.17</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td class="competency">2.4.18</td>
            <td class="competency">2.4.19</td>
            <td class="competency">2.4.20</td>
            <td class="competency">2.4.21</td>
            <td class="competency">2.4.22</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td rowspan="4">C3 Prevent, control and free fires on board</td>
            <td class="competency">3.1.8</td>
            <td class="competency">3.1.9</td>
            <td class="competency">3.1.10</td>
            <td class="competency">3.1.11</td>
            <td class="competency">3.1.12</td>
            <td class="competency">3.1.13</td>
            <td class="competency">3.1.14</td>
            <td class="competency">3.1.15</td>
            <td class="competency">3.1.16</td>
            <td class="competency">3.1.17</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td class="competency">3.2.3</td>
          </tr>
          <tr>
            <td></td>
          </tr>
          <tr>
            <td rowspan="2">C4 Operate life saving appliances</td>
            <td class="competency">4.1.8</td>
            <td class="competency">4.1.9</td>
            <td class="competency">4.1.10</td>
            <td class="competency">4.1.11</td>
            <td class="competency">4.1.12</td>
            <td class="competency">4.1.13</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td rowspan="2">C5 Apply medical first aid kit on board ship</td>
            <td class="competency">5.1.3</td>
            <td class="competency">5.1.4</td>
            <td class="competency">5.1.5</td>
            <td class="competency">5.1.6</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td rowspan="2">
              C6 Monitor compliance with legislative requirements
            </td>
            <td class="competency">6.1.3</td>
            <td class="competency">6.1.4</td>
            <td class="competency">6.1.5</td>
            <td class="competency">6.1.6</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td rowspan="2">
              C7 Contribute to the safety of personnel and ship
            </td>
            <td class="competency">7.1.4</td>
          </tr>
          <tr>
            <td></td>
          </tr>
        </table>
      </div>
      <div class="div-d">
        <h6>Ship security</h6>
        <table>
          <tr>
            <td rowspan="2">
              D1- Controlling to the enhancement of maritime security through
              hightened awareness
            </td>
            <td class="competency">1.1.4</td>
            <td class="competency">1.1.5</td>
            <td class="competency">1.1.6</td>
            <td class="competency">1.1.7</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </table>
      </div>
    </div>

{/* div -16  */}

<div class="div-16 saperate-page text-start">
    <h5 class="text-start">Semester 5</h5>
    <div class="div-a">
        <h6 class="text-start">Navigation</h6>
        <table>
            <tbody>
                <tr>
                    <td rowspan="4">A1- Plan and conduct a passage and determine position</td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=OTg=&rd_index=undefined">1.4.1</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=OTg=&rd_index=undefined">1.4.2</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=OTg=&rd_index=undefined">1.4.3</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=OTg=&rd_index=undefined">1.4.4</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=OTk=&rd_index=undefined">1.5.2</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTAw&rd_index=undefined">1.5.3</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTAy&rd_index=undefined">1.5.4</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTAy&rd_index=undefined">1.5.5</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTAz&rd_index=undefined">1.6.3</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTA0&rd_index=undefined">1.8.4</a></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTA1&rd_index=undefined">1.8.5</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTA2&rd_index=undefined">1.8.6</a></td>
                     <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTA3&rd_index=undefined">1.9.9</a></td>
                     <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTA3&rd_index=undefined">1.9.10</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTA4&rd_index=undefined">1.9.11</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTA5&rd_index=undefined">1.9.12</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTEw&rd_index=undefined">1.9.13</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTEw&rd_index=undefined">1.9.14</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTEx&rd_index=undefined">1.9.15</a></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td rowspan="4">A2- Maintain a safe navigational watch</td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTEy&rd_index=undefined">2.1.7</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTEy&rd_index=undefined">2.1.8</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTEy&rd_index=undefined">2.1.9</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTEz&rd_index=undefined">2.1.10</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTEz&rd_index=undefined">2.1.11</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTEy&rd_index=undefined">2.1.12</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTE0&rd_index=undefined">2.1.13</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTE0&rd_index=undefined">2.1.14</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTE1&rd_index=undefined">2.1.15</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTE2&rd_index=undefined">2.2.5</a></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTE3&rd_index=undefined">2.2.6</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTE4&rd_index=undefined">2.2.7</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTE5&rd_index=undefined">2.2.8</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTIw&rd_index=undefined">2.2.9</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTIx&rd_index=undefined">2.3.3</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTIx&rd_index=undefined">2.3.4</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTIy&rd_index=undefined">2.4.2</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTIz&rd_index=undefined">2.4.3</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTIy&rd_index=undefined">2.4.4</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTIy&rd_index=undefined">2.4.5</a></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>A3- Use of radar and ARPA to maintain safety of navigation</td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTI0&rd_index=undefined">3.1.9</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTI0&rd_index=undefined">3.1.10</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTI1&rd_index=undefined">3.2.6</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTI2&rd_index=undefined">3.2.7</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTI1&rd_index=undefined">3.2.8</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTI0&rd_index=undefined">3.2.9</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTI1&rd_index=undefined">3.2.10</a></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>A4- Use of ECDIS to maintain safety of navigation</td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTI4&rd_index=undefined">4.1.8</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTI4&rd_index=undefined">4.1.9</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTI4&rd_index=undefined4.1.10">4.1.10</a></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td rowspan="2">A5- Reposnd to Emergency</td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTI5&rd_index=undefined">5.2.6</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTI5&rd_index=undefined">5.2.7</a></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td rowspan="2">A6- Respond to a distress signal at sea</td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTMw&rd_index=undefined">6.1.10</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTMx&rd_index=undefined">6.1.11</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTMx&rd_index=undefined">6.1.12</a></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td rowspan="2">A7- Use the IMO Standard Marine Communication Phrases and use English in written and oral</td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTMy&rd_index=undefined">7.2.6</a></td>
                </tr>
                <tr>
                    <td></td>
                </tr>
                <tr>
                    <td rowspan="2">A9- Manoeuvre the ship</td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTMz&rd_index=undefined">9.1.5</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTM0&rd_index=undefined">9.2.14</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTM1&rd_index=undefined">9.2.15</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTM2&rd_index=undefined">9.2.16</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTM3&rd_index=undefined">9.2.17</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTM4&rd_index=undefined">9.2.18</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTM5&rd_index=undefined">9.3.1</a></td>
                    <td class="light-blue"><a class="chrf" chrf="https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf=MTM5&rd_index=undefined">9.3.2</a></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
        </table>
       </div>
       <div class="div-b">
        <h6 class="text-start">Cargo handling and stowave</h6>
        <table>
            <tbody>
                <tr>
                    <td rowspan="4">B1- Monitor the loading, stowave, securing, care during the voyage and unloading the cargos</td>
                    <td class="light-blue">1.2.6</td>
                    <td class="light-blue">1.2.7</td>
                    <td class="light-blue">1.3.10</td>
                    <td class="light-blue">1.3.11</td>
                    <td class="light-blue">1.3.12</td>
                    <td class="light-blue">1.3.13</td>
                    <td class="light-blue">1.4.1</td>
                    <td class="light-blue">1.4.2</td>
                    <td class="light-blue">1.4.3</td>
                    <td class="light-blue">1.4.4</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td class="light-blue">1.4.5</td>
                    <td class="light-blue">1.6.1</td>
                    <td class="light-blue">1.6.2</td>
                    <td class="light-blue">1.6.3</td>
                    <td class="light-blue">1.6.4</td>
                    <td class="light-blue">1.6.5</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td rowspan="2">B2 - Inspect and report defects and damage to cargo spaces, hatch over and ballast tanks</td>
                    <td class="light-blue">2.1.11</td>
                    <td class="light-blue">2.1.12</td>
                    <td class="light-blue">2.1.13</td>
                    <td class="light-blue">2.1.14</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
        </table>
       </div>
       <div class="div-c">
        <h6 class="text-start">Controlling the operation of the ship and care for persolls on board</h6>
        <table>
            <tbody>
                <tr>
                    <td rowspan="2">C1- Ensure compliance with polution prevention requirements</td>
                    <td class="light-blue">1.1.8</td>
                    <td class="light-blue">1.1.9</td>
                    <td class="light-blue">1.1.10</td>
                    <td class="light-blue">1.1.11</td>
                    <td class="light-blue">1.1.12</td>
                    <td class="light-blue">1.2.8</td>
                    <td class="light-blue">1.2.9</td>
                    <td class="light-blue">1.2.10</td>
                    <td class="light-blue">1.2.11</td>
                    <td class="light-blue">1.2.12</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td rowspan="2">C2- maintain seaworthiness of the ship</td>
                    <td class="light-blue">2.1.2</td>
                    <td class="light-blue">2.1.3</td>
                    <td class="light-blue">2.1.4</td>
                    <td class="light-blue">2.1.5</td>
                    <td class="light-blue">2.1.6</td>
                    <td class="light-blue">2.2.2</td>
                    <td class="light-blue">2.2.3</td>
                    <td class="light-blue">2.4.23</td>
                    <td class="light-blue">2.4.24</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td rowspan="2">C3- Prevent, control and fight fires on board</td>
                    <td class="light-blue">3.1.18</td>
                    <td class="light-blue">3.1.19</td>
                    <td class="light-blue">3.2.4</td>
                    <td class="light-blue">3.2.5</td>
                    <td class="light-blue">3.2.6</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td rowspan="2">C4- Operate life saving appliances</td>
                    <td class="light-blue">4.1.14</td>
                    <td class="light-blue">4.1.15</td>
                    <td class="light-blue">4.1.16</td>
                    <td class="light-blue">4.1.17</td>
                    <td class="light-blue">4.1.18</td>
                    <td class="light-blue">4.1.19</td>
                    <td class="light-blue">4.1.20</td>
                    <td class="light-blue">4.1.21</td>
                    <td class="light-blue">4.1.22</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td rowspan="2">C5- Apply medical first aid on board</td>
                    <td class="light-blue">5.2.1</td>
                    <td class="light-blue">5.2.2</td>
                    <td class="light-blue">5.2.3</td>
                    <td class="light-blue">5.2.4</td>
                    <td class="light-blue">5.2.5</td>
                    <td class="light-blue">5.2.6</td>
                    <td class="light-blue">5.2.7</td>
                    <td class="light-blue">5.2.8</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td rowspan="2">C7- Contribute to the safety of personnel and ship</td>
                    <td class="light-blue">7.1.5</td>
                    <td class="light-blue">7.1.6</td>
                    <td class="light-blue">7.1.7</td>
                    <td class="light-blue">7.1.8</td>
                </tr>
            </tbody>
        </table>
       </div>
       <div class="div-d">
        <h6 class="text-start">Ship Security</h6>
        <table>
            <tbody>
                <tr>
                    <td rowspan="2">D1- contribute to the enhancement of maritime security through hightened awareness</td>
                     <td class="light-blue">1.1.8</td>
                     <td class="light-blue">1.1.9</td>
                     <td class="light-blue">1.1.10</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
        </table>
       </div>
   </div>

{/* div-17  */}
   <div class="div-17 saperate-page text-start">
        <div class="table-container">
            <div class="section-title text-start">
              Additional tasks (cargo operations) for tankers - general
            </div>
            <table>
              <tbody>
                <tr>
                  <td rowspan="8">E1- Contribute to the safe cargo operations</td>
                  <td>1.1.1</td>
                  <td>1.1.2</td>
                  <td>1.1.3</td>
                  <td>1.1.4</td>
                  <td>1.1.5</td>
                  <td>1.1.6</td>
                  <td>1.1.7</td>
                  <td>1.1.8</td>
                  <td>1.1.9</td>
                  <td>1.1.10</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>1.1.11</td>
                  <td>1.1.12</td>
                  <td>1.1.13</td>
                  <td>1.1.14</td>
                  <td>1.1.15</td>
                  <td>1.1.16</td>
                  <td>1.1.17</td>
                  <td>1.1.18</td>
                  <td>1.1.19</td>
                  <td>1.1.20</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>1.1.21</td>
                  <td>1.1.22</td>
                  <td>1.1.23</td>
                  <td>1.2.1</td>
                  <td>1.2.2</td>
                  <td>1.2.3</td>
                  <td>1.2.4</td>
                  <td>1.2.5</td>
                  <td>1.2.6</td>
                  <td>1.2.7</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>1.2.8</td>
                  <td>1.2.9</td>
                  <td>1.2.10</td>
                  <td>1.3.1</td>
                  <td>1.3.2</td>
                  <td>1.3.3</td>
                  <td>1.3.4</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
      
          <div class="table-container">
            <div class="section-title text-start">
              Additional tasks (cargo operations) for oil tankers
            </div>
            <table>
              <tbody>
                <tr>
                  <td rowspan="8">F1- Contribute to the safe cargo operations</td>
                  <td>1.1.1</td>
                  <td>1.1.2</td>
                  <td>1.1.3</td>
                  <td>1.1.4</td>
                  <td>1.1.5</td>
                  <td>1.1.6</td>
                  <td>1.1.7</td>
                  <td>1.1.8</td>
                  <td>1.1.9</td>
                  <td>1.1.10</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>1.1.11</td>
                  <td>1.1.12</td>
                  <td>1.1.13</td>
                  <td>1.1.14</td>
                  <td>1.1.15</td>
                  <td>1.1.16</td>
                  <td>1.1.17</td>
                  <td>1.1.18</td>
                  <td>1.1.19</td>
                  <td>1.1.20</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>1.1.21</td>
                  <td>1.1.22</td>
                  <td>1.1.23</td>
                  <td>1.1.24</td>
                  <td>1.1.25</td>
                  <td>1.1.26</td>
                  <td>1.1.27</td>
                  <td>1.1.28</td>
                  <td>1.1.29</td>
                  <td>1.1.30</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>1.1.31</td>
                  <td>1.1.32</td>
                  <td>1.1.33</td>
                  <td>1.2.1</td>
                  <td>1.2.2</td>
                  <td>1.2.3</td>
                  <td>1.2.4</td>
                  <td>1.3.1</td>
                  <td>1.3.2</td>
                  <td>1.3.3</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
      
          <div class="table-container">
            <div class="section-title text-start">
              Additional tasks (cargo operations) for chemical tankers
            </div>
            <table>
              <tbody>
                <tr>
                  <td rowspan="10">G1- Contribute to the safe cargo operations</td>
                  <td>1.1.1</td>
                  <td>1.1.2</td>
                  <td>1.1.3</td>
                  <td>1.1.4</td>
                  <td>1.1.5</td>
                  <td>1.1.6</td>
                  <td>1.1.7</td>
                  <td>1.1.8</td>
                  <td>1.1.9</td>
                  <td>1.1.10</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>1.1.11</td>
                  <td>1.1.12</td>
                  <td>1.1.13</td>
                  <td>1.1.14</td>
                  <td>1.1.15</td>
                  <td>1.1.16</td>
                  <td>1.1.17</td>
                  <td>1.1.18</td>
                  <td>1.1.19</td>
                  <td>1.1.20</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>1.1.21</td>
                  <td>1.1.22</td>
                  <td>1.1.23</td>
                  <td>1.1.24</td>
                  <td>1.1.25</td>
                  <td>1.1.26</td>
                  <td>1.1.27</td>
                  <td>1.1.28</td>
                  <td>1.1.29</td>
                  <td>1.1.30</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>1.2.1</td>
                  <td>1.2.2</td>
                  <td>1.2.3</td>
                  <td>1.2.4</td>
                  <td>1.2.5</td>
                  <td>1.2.6</td>
                  <td>1.2.7</td>
                  <td>1.2.8</td>
                  <td>1.2.9</td>
                  <td>1.2.10</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>1.2.11</td>
                  <td>1.2.12</td>
                  <td>1.3.1</td>
                  <td>1.3.2</td>
                  <td>1.3.3</td>
                  <td>1.3.4</td>
                  <td>1.3.5</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
    </div>

{/* div-18  */}
<div class="div-18 saperate-page text-start">
    <div class="table-container">
        <div class="section-title text-start">
          Additional tasks (cargo operations) for gas carriers
        </div>
        <table>
          <tbody>
            <tr>
              <td rowspan="16"> H1- Contribute to the safe cargo operation of a liquefied gas tanker and
                  have a basic knowledge of the physical properties of liquefied gases</td>
              <td>1.1.1</td>
              <td>1.1.2</td>
              <td>1.1.3</td>
              <td>1.1.4</td>
              <td>1.1.5</td>
              <td>1.1.6</td>
              <td>1.1.7</td>
              <td>1.1.8</td>
              <td>1.1.9</td>
              <td>1.1.10</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>1.1.11</td>
              <td>1.1.12</td>
              <td>1.1.13</td>
              <td>1.1.14</td>
              <td>1.1.15</td>
              <td>1.1.16</td>
              <td>1.1.17</td>
              <td>1.1.18</td>
              <td>1.1.19</td>
              <td>1.1.20</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>1.1.21</td>
              <td>1.1.22</td>
              <td>1.1.23</td>
              <td>1.1.24</td>
              <td>1.1.25</td>
              <td>1.1.26</td>
              <td>1.1.27</td>
              <td>1.1.28</td>
              <td>1.1.29</td>
              <td>1.1.30</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>1.1.31</td>
              <td>1.1.32</td>
              <td>1.1.33</td>
              <td>1.1.34</td>
              <td>1.1.35</td>
              <td>1.1.36</td>
              <td>1.1.37</td>
              <td>1.1.38</td>
              <td>1.1.39</td>
              <td>1.1.40</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>1.1.41</td>
              <td>1.1.42</td>
              <td>1.1.43</td>
              <td>1.1.44</td>
              <td>1.1.45</td>
              <td>1.1.46</td>
              <td>1.1.47</td>
              <td>1.1.48</td>
              <td>1.1.49</td>
              <td>1.1.50</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>1.1.51</td>
              <td>1.1.52</td>
              <td>1.1.53</td>
              <td>1.1.54</td>
              <td>1.1.55</td>
              <td>1.1.56</td>
              <td>1.1.57</td>
              <td>1.1.58</td>
              <td>1.1.59</td>
              <td>1.2.1</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>1.2.2</td>
              <td>1.2.3</td>
              <td>1.2.4</td>
              <td>1.2.5</td>
              <td>1.2.6</td>
              <td>1.2.7</td>
              <td>1.2.8</td>
              <td>1.2.9</td>
              <td>1.2.10</td>
              <td>1.2.11</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>1.3.1</td>
              <td>1.3.2</td>
              <td>1.3.3</td>
              <td>1.3.4</td>
              <td>1.3.5</td>
              <td>1.3.6</td>
              <td>1.3.7</td>
              <td>1.3.8</td>
              <td>1.3.9</td>
              <td>1.3.10</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
  
      <div class="table-container">
        <div class="section-title text-start">
          Additional tasks for shipboard operations on passenger ships
        </div>
        <table>
          <tbody>
            <tr>
              <td rowspan="2"> I 1- Control passengers and other personnel during emergency situations,
                  and establish and maintain effective communications</td>
              <td>1.1.1</td>
              <td>1.1.2</td>
              <td>1.1.3</td>
              <td>1.1.4</td>
              <td>1.1.5</td>
              <td>1.1.6</td>
              <td>1.1.7</td>
              <td>1.1.8</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-container">
        <div class="section-title text-start">
          Additional tasks for cargo operations on ro-ro ships
        </div>
        <table>
          <tbody>
            <tr>
              <td rowspan="2">J1- Contribute to the safe cargo operation of ro-ro ships with due
                  regard for safety of life at sea and protection of the marine
                  environment</td>
              <td>1.1.1</td>
              <td>1.1.2</td>
              <td>1.1.3</td>
              <td>1.1.4</td>
              <td>1.1.5</td>
              <td>1.1.6</td>
              <td>1.1.7</td>
              <td>1.1.8</td>
              <td>1.1.9</td>
              <td>1.1.10</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
  </div>

{/* div-19  */}
<div class="div-19 saperate-page text-start">
        <h6>Additional tasks for ships operating in polar waters/ winter conditions</h6>
    <table>
            <tr>
                <td rowspan="4">K1- Contribute to the safe operation of ships operating in polar waters and winter conditions with due regard for safety of life at sea and protection of the marine environment</td>
                <td>1.1.1</td>
                <td>1.1.2</td>
                <td>1.1.3</td>
                <td>1.1.4</td>
                <td>1.1.5</td>
                <td>1.1.6</td>
                <td>1.1.7</td>
                <td>1.1.8</td>
                <td>1.1.9</td>
                <td>1.1.10</td>
            </tr>
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td>1.1.11</td>
            </tr>
            <tr>
                <td></td>
            </tr>
    </table>

    <h6>Additional tasks for dynamic positioning (DP) vessels</h6>
    <table>
         <tr>
             <td rowspan="2" >L1- Operate vessels safely in DP mode with due regard for safety off life at sea and protection of the marine environment</td>
                <td>1.1.1</td>
                <td>1.1.2</td>
                <td>1.1.3</td>
                <td>1.1.4</td>
                <td>1.1.5</td>
                <td>1.1.6</td>
                <td>1.1.7</td>
                <td>1.1.8</td>
                <td>1.1.9</td>
                <td>1.1.10</td>
            </tr>
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
    </table>

    <h6>Additional tasks for offshore supply vessels</h6>
    <table>
            <tr>
                <td rowspan="2">M1- Contribute to the safe operation of offshore vessels with due regard for safety of life at sea and protection of the marine environment</td>
                <td>1.1.1</td>
                <td>1.1.2</td>
                <td>1.1.3</td>
                <td>1.1.4</td>
                <td>1.1.5</td>
                <td>1.1.6</td>
                <td>1.1.7</td>
                <td>1.1.8</td>
                <td>1.1.9</td>
                <td>1.1.10</td>
            </tr>
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
    </table>
    </div>



        </section>
    );
}

export default Comp_Cadet_Record_Book